import React, { useEffect } from "react";
import "../css/App.css";
import {
    createMuiTheme,
    MuiThemeProvider,
} from "@material-ui/core/styles";

import Splash from "./Splash";
import { init } from "../../viewmodel/providers/login";
import AppRouter from "./AppRouter";
import { useApp } from "../../viewmodel/hooks/getApp";
import { setAuthInterceptor } from "../../utils/api";
import Login from "./Login";
import { UserContext } from "../../viewmodel/providers/user-context";
import { SoundContext } from "../../viewmodel/providers/sound-context";
import { SoundEffectContext } from "../../viewmodel/providers/soundEffect-context";

const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#333332",
            contrastText: "#fff",
        },
        secondary: {
            main: "#959EA7",
            contrastText: "#333332",
        },
    },
    typography: {
        fontFamily: [
            "Saira Extra Condensed",
            "sans-serif",
        ].join(","),
        body1: {
            fontFamily: "Comic Sans",
        },
    },
    overrides: {
        MuiPaper: {
            root: {
                backgroundColor: "unset",
            },
        },
    },
});

export default function App(): JSX.Element {

    const [state, , setAuthenticated, setStates, addNotification, shownNotification,
        setSound, setSoundEffect] = useApp();

    let content: JSX.Element;

    useEffect(() => {
        setAuthInterceptor(setAuthenticated);
        init(setStates);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (state.isLoading) {
        content = <Splash />;
    } else {
        if (state.authenticated)
            content = (
                <UserContext.Provider
                    value={{
                        userId: state.userId,
                        notifications: state.notifications,
                        addNotification: (notification: any) => {
                            addNotification(notification);
                        },
                        shownNotification: (notification:any) => {
                            shownNotification(notification);
                        },
                    }}
                >
                    <SoundContext.Provider
                        value={{ sound: state.sound, setSound: (sound: boolean) => {
                            setSound(sound);
                        } }}
                    >
                        <SoundEffectContext.Provider
                            value={{ soundEffect: state.soundEffect, setSoundEffect: (soundEffect: boolean) => {
                                setSoundEffect(soundEffect);
                            } }}
                        >
                            <AppRouter />
                        </SoundEffectContext.Provider>
                    </SoundContext.Provider>
                </UserContext.Provider>

            );

        else {
            content = <Login />;
        }
    }

    return (
        <div id={"AppWrapper"}>
            <MuiThemeProvider theme={theme}>
                {content}
            </MuiThemeProvider>
        </div>
    );
}
